export default __webpack_public_path__ + "static/media/SchraderLogoPrimary.3ea5b885.svg";